export class SortedField {
    constructor(
        public field: string,
        public direction: 'asc' | 'desc' = 'asc',
    ) {}

    toQueryString(): string {
        return `sort=${this.field},${this.direction}`;
    }
}

export class Sorting {
    public static readonly ASC = 'asc';
    public static readonly DESC = 'desc';
    private readonly fields: SortedField[] = [];

    constructor(fields: SortedField[] = []) {
        this.fields.push(...fields);
    }

    addField(field: SortedField): void {
        if (!field || !field.field) {
            throw new Error(
                'Field and direction must be provided for the sorted field.',
            );
        }

        // Verifica se o campo já existe e atualiza a direção, caso exista.
        const existingField = this.fields.find((f) => f.field === field.field);

        if (existingField) {
            existingField.direction = field.direction;
            return;
        }

        this.fields.push(field);
    }

    toQueryString(): string {
        return this.fields.map((field) => field.toQueryString()).join('&');
    }
}
